// Letters of any script (English, Dari, Pashto, Uzbeki — incl. Uzbek Latin ʻ/ʼ modifier letters),
// combining marks (Arabic diacritics), whitespace and zero-width (non-)joiners used in Dari / Pashto names.
// Digits and special characters remain disallowed.
const PERSON_NAME_REGEX = /^[\p{L}\p{M}\s‌‍]*$/u;

export function isValidPersonName(value: string): boolean {
  return PERSON_NAME_REGEX.test(value);
}
